import { combineReducers } from "redux";
import eventReducer from "./eventReducer";
import fixtureReducer from "./fixtureReducer";
import teamReducer from "./teamReducer";
import playerReducer from "./playerReducer";
import betReducer from "./betReducer";
import statisticsReducer from "./statisticsReducer";

// COMBINED REDUCERS
const rootReducer = combineReducers({
  events: eventReducer,
  fixtures: fixtureReducer,
  teams: teamReducer,
  players: playerReducer,
  bets: betReducer,
  statistics: statisticsReducer,
});

export default rootReducer;
